import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AllHomeWorkPricing = () => {
  const [homeWorkPricing, setHomeWorkPricing] = useState([]);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const fetchHomeWorkPrice = () => {
    axios
      .get(`${API_BASE_URL}/pricing/home-work`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        // console.log(result?.data?.data);
        const data = result?.data?.data;
        setHomeWorkPricing(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchHomeWorkPrice();
  }, []);
  const handleAddNewHomeWorkPricing = () => {
    navigate("/add-home-work-pricing");
  };
  const handleViewAllHomeWorkPricing = () => {
    navigate("/all-home-work-pricing");
  };

  const handleEdit = (id) => {
    navigate(`/edit-home-work-pricing/${id}`);
  };
  const handleDelete = (id) => {
    const confirm = window.confirm(
      "Are you sure you want to delete Home Work Pricing ?"
    );
    if (confirm) {
      axios
        .delete(`${API_BASE_URL}/admin/pricing/home-work/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((result) => {
          console.log(result);
          alert("Home Work Price Deleted Successfully");
          fetchHomeWorkPrice();
        })
        .catch((error) => {
          console.log(error);
          alert("Error while deleting Price");
        });
    }
  };
  return (
    <div id="classes-inner-wrapper">
      <div className="classes-header-div">
        <h5>Home Work Pricing</h5>
        <div className="classes-header-btns">
          <button
            className="add-class-btn"
            onClick={handleAddNewHomeWorkPricing}
          >
            + Add New Pricing
          </button>
          <button
            className="all-classes-btn"
            onClick={handleViewAllHomeWorkPricing}
          >
            All Pricing
          </button>
        </div>
      </div>

      {/* <WelcomeBack /> */}

      <div className="classes-table-container">
        <h5>All Home Work Pricing</h5>
        <table className="classes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Class</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            {/* Sample data rows */}

            {homeWorkPricing &&
              homeWorkPricing.map((data, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{data?.classId?.className}</td>
                  <td>{data?.price}</td>
                  <td className="table-action-icons">
                    <i
                      className="fa-solid fa-file-pen"
                      onClick={() => handleEdit(data._id)}
                    ></i>
                    &nbsp;&nbsp;
                    <i
                      className="fa-solid fa-trash-can"
                      onClick={() => handleDelete(data._id)}
                    ></i>
                  </td>
                </tr>
              ))}

            {/* Add more rows as needed */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllHomeWorkPricing;
